import React from 'react';
import { Alert, Typography } from '@mui/material';

function StreakLastBreakPanel({ lastStreakBreak }) {
  if (!lastStreakBreak) return null;

  const metadata = lastStreakBreak.metadata || {};
  const localDate = metadata.localDate || '—';
  const previousStreak = metadata.previousStreak ?? '—';
  const newStreak = metadata.newStreak ?? '—';
  const missingDates = metadata.missingDailyDates || [];
  const missingLabel =
    missingDates.length > 0 ? missingDates.join(', ') : '(none)';

  return (
    <Alert severity="error" sx={{ mb: 2 }}>
      <Typography variant="subtitle2" fontWeight={700} gutterBottom>
        Last streak break: {localDate}
      </Typography>
      <Typography variant="body2">
        Previous streak: {previousStreak} → reset to {newStreak}
      </Typography>
      <Typography variant="body2">
        Missing daily dates: {missingLabel}
      </Typography>
      {lastStreakBreak.reason && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {lastStreakBreak.reason}
        </Typography>
      )}
    </Alert>
  );
}

export default StreakLastBreakPanel;
